import React from 'react';
import { Member } from '../elements/Member';

export const CorporateTeam = (props) => {
    
    const {corporateMembers} = props.content;

    return (
            corporateMembers &&
            <section className="kiwi-members__corporate">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <ul className="members__list list-unstyled">
                                {corporateMembers.map((member, i) => {
                                    return <Member key={i}
                                                icon={member.url}
                                                header={member.name}
                                                description={member.jobTitle}
                                    />
                                })}
                            </ul>

                        </div>
                    </div>
                </div>
            </section>
    )
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/components/CorporateTeam.js